import React, { useEffect, useState, useRef } from 'react';
import { Pencil } from "lucide-react";
import CustomizeModal from './CustomizeModal';
import useToggleSections from 'core/services/toggleService';
import ImageWithBaseApi from 'components/common/mediaRender/ImageWithBaseApi';

const ComprarSection = ({ product, handleOptionChange, selectedOption, setSelectedSize, selectedSize }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [sections, toggleSection] = useToggleSections({ details: true, preview: false });

    const handleCustomizeSize = () => {
        setIsModalOpen(true);
    };

    const sizes = product?.product_option.filter(option => option.display_type === 'text');

    return (
        <div className="tab-pane active" role="tabpanel">
            <h3 className="text-lg font-semibold mb-2 mt-2 mb-md-0 color-black">{product?.title}</h3>
            <p className="text-sm text-gray-600 mb-0">{product?.description}</p>
            <div className="product-meta text-sm mt-2 d-flex justify-content-between align-items-center flex-sm-nowrap">
                <div className="row w-100">
                    <div className="mt-2 mt-md-0 col-md-12">
                        <div className="card-gray shadow-sm">
                            <button type="button" className="use-section-toggle p-0" onClick={() => toggleSection('details')} style={{ cursor: 'pointer' }}>
                            ¿Dónde puedes aplicarlo? Descúbrelo aquí
                                <i className={`me-3 fas fa-chevron-${sections?.details ? 'up' : 'down'}`} />
                            </button>
                            <div className={`set-section-content ${sections?.details ? 'open' : ''}`}>
                                <ul className={`d-flex flex-wrap text-gray-700 list-unstyled m-0 set-section-content`} style={{ maxHeight: '20rem', overflow: 'hidden' }}>
                                    {product?.details?.slice(0, 6)?.map((detail) => (<li key={detail.id} className="d-flex align-items-center m-0" style={{ flex: '1 0 45%', marginBottom: '0.5rem' }}><i className={`${detail.attribute} me-2`}></i>{detail.label}</li>))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr className="my-3" style={{ opacity: 'unset', color: '#e9e9e9', border: '#e9e9e9 0.01px solid', height: '0.1px' }} />
            {sizes?.length > 0 && (
                <div className="mb-2">
                    <div>
                        <ul className="list-unstyled m-0">
                            <li>
                                <strong className="text-title">Tamaños Disponibles:</strong>
                                <ul className="d-flex flex-wrap gap-2 list-unstyled mt-1">
                                    {sizes?.map((size, index) => (
                                        <li className="m-0" key={index}>
                                            <button
                                                onClick={() => setSelectedSize(selectedSize?.id === size?.id ? null : size)}
                                                className={`btn py-2 px-0 btn-sm size-button ${selectedSize?.id === size?.id ? 'ltn__secondary-bg-im white-color-im' : 'btn-outline-secondary '}`}
                                            >
                                                <label className="mx-3"> {size?.value} </label>
                                                {size?.type === 'new' && (
                                                    <span className="badge bg-danger me-2" style={{ fontSize: '0.75rem' }}>Nuevo</span>
                                                )}
                                            </button>
                                        </li>
                                    ))}
                                    <li className="m-0">
                                        <button
                                            onClick={handleCustomizeSize}
                                            className="btn py-2 px-3 btn-outline min-w-80"
                                        >
                                            <Pencil className="me-2" size={15} />
                                            <span style={{ fontWeight: '500' }}>
                                                Hazlo único
                                            </span>
                                        </button>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
            )}
            {product?.product_option?.some(option => ['image', 'color'].includes(option.display_type)) && (
                <div className="mb-3">
                    <ul className="list-unstyled m-0">
                        <li className="m-0 d-flex justify-content-between align-items-start">
                            <strong className="text-title">Opciones Disponibles:</strong>
                        </li>
                        <ul className="scroll-light gap-2 pe-0 list-unstyled mt-1">
                            {product?.product_option?.map((option, index) => {
                                if (option.display_type === 'image') {
                                    return (
                                        <li className="m-0" key={index} style={{ minWidth: '40px', minHeight:'40px' }} onClick={() => handleOptionChange(option, index)}>
                                            <ImageWithBaseApi
                                                loadingIconFontSize="20px"
                                                src={option?.url}
                                                alt={`Opción ${index + 1}`}
                                                className={`img-thumbnail ${selectedOption?.url === option?.url ? 'ltn__border-primary' : ''}`}
                                                style={{ width: '50px', height: '50px', cursor: 'pointer' }}
                                            />
                                        </li>
                                    );
                                } else if (option.display_type === 'color') {
                                    return (
                                        <li className="m-0" key={index} onClick={() => handleOptionChange(option, index)}>
                                            <div
                                                className={`option-color ${selectedOption?.value === option?.value ? 'ltn__border-primary' : ''}`}
                                                style={{ backgroundColor: option.value, width: '50px', height: '50px', cursor: 'pointer' }}
                                            />
                                        </li>
                                    );
                                }
                                return null;
                            })}
                        </ul>
                    </ul>
                </div>
            )}
            <CustomizeModal isOpen={isModalOpen} onRequestClose={() => setIsModalOpen(false)} product={product} />
        </div>
    );
};

export default ComprarSection;
